export default __webpack_public_path__ + "static/media/3.daca6c8c.png";